<template>
    <div>
        <div :id="modalId" class="modal fade" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div :class="'modal-dialog modal-dialog-centered modal-' + size">
                <div class="modal-content">
                    <button
                        v-if="showClose"
                        type="button"
                        class="modal-swal-close"
                        :aria-label="$t('Nav.close')"
                        @click="close"
                    >
                        &times;
                    </button>
                    <div v-if="!hideHeader" class="modal-header pb-0" :class="headerClass">
                        <slot name="header">
                            <h4 v-if="title" class="pt-1">{{ title }}</h4>
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot></slot>
                    </div>
                    <div v-if="!hideFooter" class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';
export default {
    name: 'Modal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: true
        },
        hideHeader: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: 'lg'
        },
        showClose: {
            type: Boolean,
            default: true
        },
        closeOnEsc: {
            type: Boolean,
            default: false
        },
        closeOnBackdrop: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        optionBackdrop: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            modal: null,
            modalId: `modal-${Date.now()}-${Math.random().toString(36).substring(2, 9)}` // unique ID for the modal
        };
    },
    computed: {
        headerClass() {
            if (this.title) return 'd-flex justify-content-start';
            return '';
        }
    },
    watch: {
        show(newVal) {
            newVal ? this.modal?.show() : this.modal?.hide();
        },
    },
    mounted() {
        // move modal to body to avoid nesting issues
        document.body.appendChild(this.$el.querySelector('.modal'));

        const el = document.getElementById(this.modalId);
        const options = {
            keyboard: this.closeOnEsc,
            backdrop: this.optionBackdrop || (this.closeOnBackdrop ? true : 'static')
        };
        this.modal = new Modal(el, options);
        el.addEventListener('hidden.bs.modal', () => {
            this.close();
        });

        // auto-show if `show` was already true
        if (this.show) {
            this.modal.show();
        }
    },
    beforeDestroy() {
        const wasShowing = this.modal && document.getElementById(this.modalId)?.classList.contains('show');
        if (this.modal) {
            const visibleModals = document.querySelectorAll('.modal.show');
            const otherVisibleModals = wasShowing ? visibleModals.length - 1 : visibleModals.length;
            this.modal.dispose();
            // only clean up body state if no other modals are visible
            if (wasShowing && otherVisibleModals === 0) {
                document.body.classList.remove('modal-open');
                document.body.style.removeProperty('overflow');
                document.body.style.removeProperty('padding-right');
                // remove only orphaned backdrops (Bootstrap 5 typically manages one per modal)
                const backdrops = document.querySelectorAll('.modal-backdrop');
                if (backdrops.length > otherVisibleModals) {
                    backdrops[backdrops.length - 1]?.remove();
                }
            }
        }
        const modalEl = document.getElementById(this.modalId);
        if (modalEl && document.body.contains(modalEl)) {
            document.body.removeChild(modalEl);
        }
    },
    methods: {
        close() {
            this.$emit('update:show', false);
        }
    }
};
</script>
<style scoped>
.modal-swal-close {
    position: absolute;
    top: -2px;
    right: -2px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.2em;
    height: 1.2em;
    margin-top: 0;
    margin-right: 0;
    padding: 0;
    overflow: hidden;
    border: none;
    border-radius: 5px;
    background: transparent;
    color: #ccc;
    font-family: monospace;
    font-size: 2.5em;
    cursor: pointer;
    transition: color 0.1s, box-shadow 0.1s;
}
.modal-swal-close:hover,
.modal-swal-close:focus {
    transform: none;
    background: transparent;
    color: #b11f46;
    outline: none;
}
</style>